<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Haber"
    }
</script>

<style scoped>

</style>